// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'todo';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.313 16.32a1.125 1.125 0 0 1-1.125 1.126H2.812a1.125 1.125 0 0 1-1.124-1.125V1.696A1.125 1.125 0 0 1 2.813.57h7.971c.298 0 .584.118.795.33l4.404 4.403c.211.21.33.497.33.795z' />
    <path d='M16.313 6.196h-4.5a1.125 1.125 0 0 1-1.126-1.125V.57M7.252 7.214l-1.6 2.132a.563.563 0 0 1-.847.06l-.867-.867m3.314 3.738-1.6 2.131a.563.563 0 0 1-.847.06l-.867-.867M9.563 9.57h3.374m-3.374 4.5h3.374' />
  </g>
);

export const viewBox = '0 0 18 18';
